import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss']
})
export class SearchFieldComponent implements OnInit {
  @Input() labelKey: string | LocLabel | null | undefined;
  @Input() colors: ColorSchemes = ColorSchemes.PRIMARY;

  @Input() search!: string;
  @Output() searchChange = new EventEmitter<string>();

  @Input() gray: boolean = false;

  ColorSchemes = ColorSchemes;
  constructor() {
    this.labelKey = 'label.search';
  }

  ngOnInit(): void {}
}
